import React, {useState, useEffect }  from 'react';
import {ToasterProvider, useToaster} from "../../../global-components/toaster.jsx";
import {__, _nonce, _solea_get_local_groups} from '../../../../../assets/javascripts/library.js';
import ReactDOM from "react-dom/client";
import Modal from "../../../global-components/modal.jsx";
import Settings from "../settings.jsx";

function ShowOrEditSolidarityBasedFees({event}) {
    const [noAmount, setNoAmount] = useState(false);
    const [formData, setFormData] = useState({
        id: event.id || 0,
        amount_social: event.edit.amount_social || __('Keep free to ignore', 'solea'),
        amount_reduced: event.edit.amount_reduced || __('Keep free to ignore', 'solea'),
        amount_participant: event.edit.amount_participant || '',
    });

    const returnToSettings = () => {
        const response = fetch("/wp-json/solea/event-details/print-page/settings", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                event_id: event.id,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                const container = document.getElementById('solea_event_group_contents');
                const root = ReactDOM.createRoot(container);
                root.render(
                    <ToasterProvider>
                        <Settings result={data.result} toast_message={data.message} />
                    </ToasterProvider>
                );
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        if (!event.editable) return;

        if ('' === formData.amount_participant ) {
            setNoAmount(true);
            return;
        }


        const response = fetch("/wp-json/solea/event-details/print-page/payment-fees/save/solidaritybased", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                formData,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                const container = document.getElementById('solea_event_group_contents');
                const root = ReactDOM.createRoot(container);
                root.render(
                    <ToasterProvider>
                            <Settings result={data.result} toast_message={data.message} />
                    </ToasterProvider>
                );
            });
    };

    const css_class = event.editable ? 'solea-participation-fees-table-editable' : 'solea-participation-fees-table-readonly';

    return (
        <div>
            <table  class={css_class}>
                <tr>
                    <td>
                        <label>
                            {__('Regular amount', 'solea')}:
                        </label>
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={formData.amount_participant}
                            name="amount_participant"
                            onChange={handleChange}
                        /> {__('Euro  total', 'solea')}
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>
                            {__('Reduced amount', 'solea')}:
                        </label>
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={formData.amount_reduced}
                            name="amount_reduced"
                            onChange={handleChange}
                        /> {__('Euro  total', 'solea')}
                    </td>
                </tr>

                <tr>
                    <td>
                        <label>
                            {__('Social amount', 'solea')}:
                        </label>
                    </td>
                    <td>
                        <input
                            readOnly={!event.editable}
                            type="text"
                            defaultValue={formData.amount_social}
                            name="amount_social"
                            onChange={handleChange}
                        />  {__('Euro  total', 'solea')}
                    </td>
                </tr>
            </table>
            <p>
                {
                    event.editable ? (
                        <button onClick={handleSubmit} class="button solea-button mr-10">{__('Save payment details', 'solea')}</button>
                    ) : ('')
                }

                {
                    event.edit.amount_participant != null ? (
                        <button onClick={returnToSettings} className="button solea-button cancel">{__('Return', 'solea')}</button>
                    ) : ('')
                }


            </p>

            <Modal title={__('No participant amount specified', 'solea')} isOpen={noAmount} onClose={() => setNoAmount(false)}>
                <p>
                    {__('You have to declare at least the regular fee. If the event is free of charge, please enter "0,00" as amount.', 'solea')}
                </p>
            </Modal>
        </div>
    )
}

export default ShowOrEditSolidarityBasedFees;